import { render, staticRenderFns } from "./FavoriteCardSkeleton.vue?vue&type=template&id=262c0c01&scoped=true&"
import script from "./FavoriteCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./FavoriteCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteCardSkeleton.vue?vue&type=style&index=0&id=262c0c01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262c0c01",
  null
  
)

export default component.exports